export class ListGoodsFilterViewModel {
    typeId: any;
    createByHubId: any;
    fromHubId: any;
    toHubId: any;
    userId: any;
    statusId: any;
    transportTypeId: any;
    tplId: any;
    dateFrom: any;
    dateTo: any;
}
